// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__23UKu","sendOtp":"AuthorizeToLogin_sendOtp__2V-hc"};